<template>
<div v-editable="blok" id="leistungsContent" v-bind:style="{ 'background-image': 'url(' + blok.backgroundImage + ')' }">
    <table class="leistungsTable">
        <tr>
            <td rowspan="2">
                <img id="bla" :src="blok.damenimage" alt="frisur"/>
                <h3>Damen:</h3>
                <ul>
                    <li>Schneiden</li>
                    <li>Föhnen / Stylen</li>
                    <li>Dauerwelle</li>
                    <li>Intensiv Tönung</li>
                    <li>Färben</li>
                    <li>Strähnen / Highlights</li>
                    <li>Pflanzenfarbe</li>
                    <li>Stecken</li>
                </ul>
            </td>
            <td rowspan="2">
                <img id="herrLeistungen" :src="blok.herrenimage" alt="frisur"/>
                <h3>Herren:</h3>
                <ul>
                    <li>Schneiden</li>
                    <li>Föhnen</li>
                    <li>Färben / Tönen</li>
                    <li>Hair-Tatoos</li>
                    <li>Rasur</li>
                    <li>Vollbart formen</li>
                </ul>    
            </td>
            <td>
                <h3>Zusatzleistungen</h3>
                <ul>
                    <li>Wimpernfärben</li>
                    <li>Wimpernwelle</li>
                    <li>Augenbrauen färben</li>
                    <li>Augenbrauen zupfen/harzen</li>
                    <li>Maniküre / Lackieren</li>
                    <li>Makeup</li>
                    <li>Haarverlängerungen</li>
                </ul>
            </td>
        </tr>
        <tr>
            <td>
                <h3>Solarium</h3>
                <p>Für die gesunde Bräune bieten wir Ihnen<br/>10, 20 oder 30 Minuten für Ihr Wohlbefinden.<br/>Gut für den Aufbau von Vitamin D und<br/>belebend für Ihre Psyche.<br/>Ein frischer, natürlicher Teint zeigt von <br/>Gesundheit und Jugendlichkeit.</p>
            </td>
        </tr>
    </table>
</div>
</template>

<script>
export default {
  props: ['blok'],
  data () {
    return {
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Leistungen.vue